module.exports = __webpack_public_path__ + "media/social-shorts.a513dea0.mp4";